module.exports = __webpack_public_path__ + "static/img/notice.de5a9c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer6/notice.png
// module id = LkjY
// module chunks = 1